import qs from 'qs';

export const stringify = qs.stringify;

export const parse = (s, o = {}) =>
  qs.parse(s, { ignoreQueryPrefix: true, ...o });

export default { stringify, parse };
